<template>
  <a-modal
    :confirmLoading='confirmLoading'
    :title='title'
    :visible='visible'
    :width='800'
    @cancel='handleCancel'
    @ok='handleOk'>
    <a-spin :spinning='confirmLoading'>
      <a-form-model layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}" ref="ruleForm" :rules="rules">
        <a-form-model-item  prop="name" label="基线名称">
          <a-input placeholder="请输入基线名称" v-model="model.name" />
        </a-form-model-item>
        <a-form-model-item  prop="visitId" label="关联事件">
          <a-select v-model="model.visitId"  placeholder="请选择" >
            <a-select-option
              v-for="item in visitList"
              :key="item.id"
              :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item  prop="basePointDay" label="距基点天数">
          <a-input-number v-model="model.basePointDay" placeholder="请输入距基点天数" :min="0" :precision="0" style="width: 100%"/>
        </a-form-model-item>
        <a-form-model-item  prop="advanceDay" label="最大可提前天数">
          <a-input-number v-model="model.advanceDay" placeholder="请输入最大可提前天数" :min="0" :precision="0" style="width: 100%"/>
        </a-form-model-item>
        <a-form-model-item prop="delayDay" label="最大可延后天数">
          <a-input-number v-model="model.delayDay" placeholder="请输入最大可延后天数" :min="0" :precision="0" style="width: 100%"/>
        </a-form-model-item>
        <a-form-model-item label="允许未到期作答">
          <a-switch v-model='model.answerUnexpiredBl' checked-children="是" un-checked-children="否"  />
        </a-form-model-item>
        <a-form-model-item label="允许过期作答">
          <a-switch v-model='model.answerOverdueBl' checked-children="是" un-checked-children="否"  />
        </a-form-model-item>

      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
import { postAction } from '@/api/manage'
import baseRules from '@/constants/baseRules'

export default {
  name: 'BaseLineModel',
  inject:['getVisitList'],
  data() {
    return {
      title: '基线配置',
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 }
      },
      confirmLoading: false,
      validatorRules: {},
      rules:{
        name:[baseRules.required],
        visitId:[baseRules.requiredChange],
        basePointDay:[baseRules.required],
        advanceDay:[baseRules.required],
        delayDay:[baseRules.required],
      },
      visitList:[]
    }
  },
  created() {
  },
  methods: {
    edit(record) {
      record.answerUnexpiredBl = record.answerUnexpired==='1'
      record.answerOverdueBl = record.answerOverdue==='1'
      this.model = Object.assign({}, record)
      this.visitList = this.getVisitList()
      this.visible = true
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          that.model.answerUnexpired = that.model.answerUnexpiredBl?'1':'0'
          that.model.answerOverdue = that.model.answerOverdueBl?'1':'0'
          that.confirmLoading = true;
          postAction("/project/projectPeriodItem/saveOrUpdate", that.model).then((res)=>{
            if(res.success){
              that.$message.success(res.message);
              that.$emit('ok');
              this.handleCancel()
            }else{
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
          })
        }else{
          return false;
        }
      })
    },
    handleCancel() {
      this.visible = false
    },

  }
}
</script>

<style scoped>

</style>
